
import Vue from "vue";

import { Component } from "vue-property-decorator";
import Dialog from "@/components/common/Dialog/index.vue";
import { Action } from "vuex-class";
import { ActionMethod } from "vuex";

@Component({
  name: "Header",
  components: {
    Dialog,
  },
})
export default class Header extends Vue {
  @Action setTheme!: ActionMethod;

  contrast = false;

  showModal = false;

  showLibras = false;

  header() {
    const win = window as any;
    if (this.$gtm.enabled()) {
      win.dataLayer.push({
        event: "event",
        eventCategory: "claro-flex:geral",
        eventAction: "clique:header",
        eventLabel: "logo",
      });
    }

    this.$router.push({
      name: "Home",
    });
  }

  setContrast(): void {
    const win = window as any;
    if (this.$gtm.enabled()) {
      win.dataLayer.push({
        event: "event",
        eventCategory: "claro-flex:home",
        eventAction: "clique:link",
        eventLabel: "acessibilidade:modo-de-visualizacao",
      });
    }

    if (this.contrast) {
      this.contrast = false;
      win.MondrianVanilla.setTheme("normal");
      this.setTheme("normal");
    } else {
      this.contrast = true;
      win.MondrianVanilla.setTheme("contrast");
      this.setTheme("contrast");
    }
  }

  created() {
    const handTalk = document.getElementsByClassName("ht-skip") as any;
    handTalk[0].setAttribute(
      "title",
      this.$t("accessibilityTexts.title.header.btnHands").toString()
    );
  }

  toggleLibras(): void {
    const win = window as any;
    this.showLibras = !this.showLibras;

    if (win.ht) {
      const handTalk = document.getElementsByClassName("ht-skip") as any;
      const handTalkBTN = handTalk[0].getElementsByTagName("button") as any;
      const event = new MouseEvent(
        this.showLibras ? "mouseenter" : "mouseleave",
        {
          view: window,
          bubbles: true,
          cancelable: true,
        }
      );
      handTalkBTN[0].dispatchEvent(event);
    }

    if (this.showLibras) {
      setTimeout(() => {
        this.toggleLibras();
      }, 2000);
    }
  }

  openAcessibility(): void {
    const win = window as any;
    win
      .open(
        "https://www.claro.com.br/institucional/regulatorio/acessibilidade",
        "_blank"
      )
      .focus();
  }

  showZoomModal(): void {
    const win = window as any;
    if (this.$gtm.enabled()) {
      win.dataLayer.push({
        event: "event",
        eventCategory: "claro-flex:home",
        eventAction: "clique:link",
        eventLabel: "acessibilidade:zoom",
      });
    }
    this.showModal = true;
  }

  closeModalAlert() {
    this.showModal = false;
  }

  get detectMob() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }
}
